import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Form, Button } from "react-bootstrap";
import "./RegistrationForm.css";
import { useAuth } from "./AuthProvider";
import BackgroundImage from './welcome.jpg';

const register = async (data) => {
    const response = await fetch(`/api/register/${data.id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      return true;
    } else {
      console.error(response);
      return false;
    }
};

const RegistrationForm = () => {
  const auth = useAuth();
  const { id } = useParams();
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [registration, setRegistration] = useState({
      id: '',
      username: ''
  });

  useEffect(() => {
    axios.get(`/api/register/${id}`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    })
      .then(response => {
        setRegistration(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        setError(error);
        setLoading(false);
      });
  }, [auth.token, id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const registered = await register({ username: registration.username, password, passwordRepeat, id });
    if (registered) {
        await auth.loginAction({ username: registration.username, password });
    }
    return;
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading game details: {error.message}</p>;

  return (
    <div
      className="sign-in__wrapper"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <div className="sign-in__backdrop"></div>
      <Form className="shadow p-4 bg-white rounded" onSubmit={handleSubmit}>
        <h2 className="form-title">Create account</h2>
        <Form.Group className="mb-2" controlId="username">
          <Form.Label>Username</Form.Label>
          <Form.Control
            type="text"
            value={registration.username}
            disabled
          />
        </Form.Group>
        <Form.Group className="mb-2" controlId="password">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-2" controlId="passwordRepeat">
          <Form.Label>Repeat password</Form.Label>
          <Form.Control
            type="password"
            value={passwordRepeat}
            onChange={(e) => setPasswordRepeat(e.target.value)}
            required
          />
        </Form.Group>
        {!loading ? (
          <Button className="w-100" variant="primary" type="submit">
            Register
          </Button>
        ) : (
          <Button className="w-100" variant="primary" type="submit" disabled>
            Registering ...
          </Button>
        )}
      </Form>
      <div className="w-100 mb-2 position-absolute bottom-0 start-50 translate-middle-x text-white text-center">
        FactoryLab | 2026
      </div>
    </div>
  );
};

export default RegistrationForm;
